import { useEffect, useState } from "react";
import moment from "moment";
import "moment-timezone";

import { handlePagingAll } from "../../../../components/api/APIUtilities";
import { postNotification } from "../../../../components/utilities/Notifications";
import ListResponsive from "../../../../components/other/ListResponsive";
import { Grid, Hidden, Link, Button } from "@mui/material";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import InfoContainer from "../../../../components/layout/InfoContainer";
import { globalVariables } from "../../../../global/GlobalVariables";
import { titleCase } from "../../../../components/utilities/UtilityFunctions";

export default function SubscriptionsTab(props) {
  const { user } = props;
  const [processing] = useState(false);
  const [subLoading, setSubLoading] = useState(true);
  const [subscriptions, setSubscriptions] = useState(null);

  useEffect(() => {
    const check = async () => {
      setSubLoading(true);

      try {
        var apiSubscriptions = await handlePagingAll(`/subscriptions`, {
          userId: user.id,
          subscriptionType: "subscription",
        });

        var apiOrganizationSubscriptions = await handlePagingAll(
          `/subscriptions`,
          {
            userId: user.id,
            subscriptionType: "organization",
          }
        );

        if (apiOrganizationSubscriptions?.length) {
          apiSubscriptions = [
            ...apiSubscriptions,
            ...apiOrganizationSubscriptions,
          ];
        }

        setSubscriptions(apiSubscriptions);
      } catch (err) {
        postNotification("error", err);
      }
      setSubLoading(false);
    };
    check();
  }, [user]);

  return (
    <>
      {subLoading || subscriptions?.length ? (
        <ListResponsive
          originalList={subLoading ? null : subscriptions}
          doPages
          initialRowsPerPage={24}
          rowProps={{
            headings: (
              <Hidden smDown>
                <SubscriptionRowDefault heading />
              </Hidden>
            ),

            mapFunction: (row, index) => <SubscriptionRowDefault row={row} />
          }}
        />
      ) : !subLoading && !subscriptions?.length ? (
        <InfoContainer
          title="No Active Subscriptions"
          body="You don't have any active subscriptions yet."
          ActionButton={
            <Button
              variant="contained"
              color="primary"
              href="/subscription"
              sx={{ textTransform: "none" }}
            >
              View Subscription Options
            </Button>
          }
          sx={{ mt: 1 }}
        />
      ) : (
        <></>
      )}

      {Boolean(processing) && <ModalLoadingFull />}
    </>
  );
}

const SubscriptionRowDefault = (props) => {
  const { heading, row } = props;
  const globalVars = globalVariables();
  return (
    <Grid
      item
      xs={12}
      sx={{
        p: "2px",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "4px 4px 0 0",
        backgroundColor: heading ? "table.headerBackground" : null,
        color: heading ? "table.headerColor" : null,
      }}
    >
      <Grid
        container
        alignItems="center"
        spacing={1}
        sx={{
          fontSize: "14px",
          overflow: "hidden",
        }}
      >
        <Grid item xs={12} sm={3}>
          {heading ? (
            "Type"
          ) : (
            <Link
              href={`/subscription/${row.id}`}
              underline="none"
              sx={{ display: "flex" }}
            >
              {row.stripe?.plan?.name ||
                (row.collection === "BCPStoreSubscription"
                  ? globalVars?.pricing?.products?.[
                      globalVars?.pricing?.subscriptions?.circuitSuite
                    ]?.name
                  : globalVars?.pricing?.products?.[
                      globalVars?.pricing?.subscriptions?.playerSub
                    ]?.name)}
            </Link>
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {heading ? "Source" : titleCase(row?.source || "")}
        </Grid>
        <Grid item xs={12} sm={3}>
          {heading
            ? "Status"
            : titleCase(
                row.stripe?.status || (row.active ? "active" : "inactive")
              )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {heading
            ? "Next Update"
            : row.active
              ? row.nextUpdate
                ? moment(row.nextUpdate).format("MMMM D, YYYY LT")
                : ""
              : ""}
        </Grid>
      </Grid>
    </Grid>
  );
};
